<template lang="pug">
    .mt-5
        | NOT FOUND (404)
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data () {
    return {
      info: null,
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../../less/global.less";
  .footer {
      bottom: 0;
      width: 100%;
      height: 100px;
      line-height: 60px;
      background-color: @primary;
      * {
        color: white;
      }
  }
</style>
